import Immutable from 'immutable';
import {
  FLAG_GETTING_DISTRICT_POSTAL_CODES,
  GET_DISTRICT_POSTAL_CODES,
  CLEAR_DISTRICT_POSTAL_CODES,
} from '../../../actions/types/location';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_DISTRICT_POSTAL_CODES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_DISTRICT_POSTAL_CODES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_DISTRICT_POSTAL_CODES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
